<template>
  <el-dialog
    v-model="visible"
    width="85%"
    class="addUser"
    draggable
    :before-close="adduserCancel"
  >
    <template #header>
      <div class="header">
        <h4>{{ $t("slack.addFriends") }}</h4>
      </div>
    </template>
    <div class="modal_content">
      <div class="inputBox">
        <el-select
          v-model="userID"
          :placeholder="SelectText"
          size="large"
          filterable
          collapse-tags
          :filter-method="filterUsers"
          popper-class="selectUser"
        >
          <el-option
            v-for="item in allusers"
            :key="item.user_uid"
            :label="item.nickname"
            :value="item.user_uid"
            :disabled="item.disabled"
          >
            <span style="float: left">{{ item.nickname }}</span>
            <el-icon v-if="item.disabled" class="select_icon">
              <Check />
            </el-icon>
          </el-option>
        </el-select>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="Cancel">{{ $t("slack.Cancel") }}</el-button>
        <el-button type="primary" @click="Confirm">
          {{
          $t("slack.Confirm")
          }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { HomeStore } from "../index";
import * as $axios from "../api/index";
import { debounce, extend } from "../utils";
import { Check } from "@element-plus/icons-vue";
import { useDemoStore } from "@/pinia/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  data() {
    return {
      userID: "",
      visible: false,
      allusers: [],
      userList: [],
      groupUserList: [],
      Check,
      SelectText: useDemoStore().lang == "en-us" ? "Select User" : "选择用户",
    };
  },
  computed: {
    isAddUser() {
      return HomeStore().setting.isAddUser;
    },
    addInfo() {
      return HomeStore().setting.addInfo;
    },
    friends() {
      return HomeStore().friends;
    },
    token() {
      return HomeStore().token;
    },
  },
  watch: {
    isAddUser(val) {
      this.visible = val;
      this.userID = "";
      this.userList = [];
      if (val) {
        if (this.addInfo.type == 2) {
          $axios
            .groupinfo({
              token: HomeStore().token,
              group_id: HomeStore().setting.dialogueInfo.group_id,
            })
            .then((res) => {
              this.groupUserList = res.data.info;
              this.getUser(this.groupUserList, HomeStore().allusers);
            });
        } else {
          this.getUser(this.friends, HomeStore().allusers);
        }
      }
    },
  },
  methods: {
    Cancel() {
      HomeStore().setConfig("isAddUser", false);
    },
    //邀请用户加入取消事件
    adduserCancel() {
      if (this.userID.length > 0) {
        if (useDemoStore().lang == "en-us") {
          ElMessageBox.confirm(
            "Edited information not been saved yet. Are you sure to leave?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {
              HomeStore().setConfig("isAddUser", false);
              this.userID = [];
            })
            .catch(() => {});
        } else {
          ElMessageBox.confirm(
            "已编辑的信息尚未保存。你确定要离开吗?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              HomeStore().setConfig("isAddUser", false);
              this.userID = [];
            })
            .catch(() => {});
        }
      } else {
        HomeStore().setConfig("isAddUser", false);
        this.userID = [];
      }
    },
    //添加好友事件
    Confirm() {
      HomeStore().setConfig("isAddUser", false);
      if (!this.userID) {
        if (useDemoStore().lang == "en-us") {
          ElMessage({
            type: "info",
            message: "Please Select User",
          });
        } else {
          ElMessage({
            type: "info",
            message: "请选择用户",
          });
        }
        return;
      }
      $axios
        .addfriends({
          token: this.token,
          to_id: [this.userID],
        })
        .then((res) => {
          if (useDemoStore().lang == "en-us") {
            ElMessage({
              type: "success",
              message: "success",
            });
          } else {
            ElMessage({
              type: "success",
              message: "成功",
            });
          }
          let val = res.data[res.data.length - 1];
          res.data.map((item) => {
            let index = HomeStore().friends.findIndex((friend) => {
              return friend.receiver_id == item.user_uid;
            });
            HomeStore().isError[item.user_uid] = "";
            if (index == -1) {
              item.HeadPhotoUrl = item.profile_photo;
              item.user_avatar_file_name = item.profile_photo;
              item.receiver_name = item.nickname;
              item.unread = 0;
              item.receiver_id = item.user_uid;
              HomeStore().friends.unshift(item);
              HomeStore().chatMessageList[item.user_uid] = [];
              HomeStore().isNeedQuery[item.user_uid] = true;
            }
          });
          HomeStore().isAddUser = false;
          $axios
            .getfriendAddress({
              token: HomeStore().token,
              friend_id: val.user_uid,
            })
            .then((res) => {
              if (res.data) {
                HomeStore().friend_host = res.data.user_host;
              }
            });
          HomeStore().IsPrivatechat = {
            user_uid: val.user_uid,
          };
        });
      this.userID = "";
    },
    //获取下拉用户
    getUser(userList, allusers) {
      let Ids = [];
      userList.map((item) => {
        Ids.push(String(item.user_uid));
      });
      allusers.map((item) => {
        if (item.user_uid in HomeStore().isError) {
          if (
            Ids.indexOf(String(item.user_uid)) != -1 &&
            !HomeStore().isError[item.user_uid]
          ) {
            item.disabled = true;
          }
        } else {
          if (Ids.indexOf(String(item.user_uid)) != -1) {
            item.disabled = true;
          }
        }
      });
      this.allusers = extend(allusers, true);
    },
    filterUsers: debounce(function (val) {
      let userList = [];
      HomeStore().allusers.map((item) => {
        if (
          item.nickname.toLocaleUpperCase().indexOf(val.toLocaleUpperCase()) !=
          -1
        ) {
          userList.push(item);
        }
      });
      if (this.addInfo.type == 2) {
        this.getUser(this.groupUserList, userList);
      } else {
        this.getUser(this.friends, userList);
      }
    }, 500),
  },
};
</script>
<style lang="less">
.addUser {
  .header {
    h4 {
      font-size: 18px;
      font-weight: 900;
    }
    .hintText {
      color: #333;
      font-size: 15px;
      font-weight: 700;
      line-height: 1.38461538;
      margin-top: 4px;
    }
  }
  .el-dialog__headerbtn {
    top: 10px !important;
  }
  .el-dialog__header {
    padding-bottom: 0 !important;
  }
  .el-dialog__body {
    .modal_content {
      .text {
        font-size: 15px;
        font-weight: 700;
        color: #000000;
      }
      .inputBox {
        margin-top: 15px;
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.selectUser {
  .select_icon {
    position: absolute;
    font-size: 12px;
    right: 20px;
    top: 10px;
    color: #409eff;
  }
}
</style>
